export default class RuleConfigProcess {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/ruleBuilder";
  }

  getRuleConfigProcesses() {
    return this.client.get(`${this.resourceUrl}/process`);
  }
  getRuleConfigProcessRule(processId) {
    return this.client.get(`${this.resourceUrl}/process/${processId}/ruleSet`);
  }
  getAllRuleSets() {
    return this.client.get(`${this.resourceUrl}/process/allRuleSets`);
  }
  getAllRules(loadPolicyTags) {
    return this.client.get(`${this.resourceUrl}/process/allRules`, {
      params: { loadPolicyTags: loadPolicyTags },
    });
  }
  updateRuleSetPriorities(processId, ruleSetList) {
    return this.client.post(
      `${this.resourceUrl}/process/${processId}/updatePriorities`,
      ruleSetList
    );
  }
  getRuleFields() {
    return this.client.get(`${this.resourceUrl}/fields`);
  }
  saveRuleSet(ruleSet) {
    return this.client.post(`${this.resourceUrl}/ruleSet`, ruleSet);
  }
  getRuleSetById(rulsetId) {
    return this.client.get(`${this.resourceUrl}/ruleSet/${rulsetId}`);
  }
  editRuleSet(rulsetId, priority, rulesList, deletedRulesKey) {
    return this.client.put(`${this.resourceUrl}/editRuleSet/${rulsetId}`, {
      priority,
      rulesList,
      deletedRulesKey,
    });
  }
  getRuleById(ruleKey) {
    return this.client.get(`${this.resourceUrl}/rule/${ruleKey}`);
  }
  createRule(ruleSetKey, ruleDto) {
    return this.client.post(
      `${this.resourceUrl}/createRule/${ruleSetKey}`,
      ruleDto
    );
  }
  updateRule(ruleKey, ruleDto) {
    return this.client.put(`${this.resourceUrl}/editRule/${ruleKey}`, ruleDto);
  }
  deleteRule(ruleKey) {
    return this.client.delete(`${this.resourceUrl}/deleteRule/${ruleKey}`);
  }
  updateRuleConfigProcessMatch(processKey, mappingRequest) {
    return this.client.put(
      `${this.resourceUrl}/processMatch/${processKey}`,
      mappingRequest
    );
  }

  updateRuleConfigRuleSetMatch(ruleSetKey, mappingRequest) {
    return this.client.put(
      `${this.resourceUrl}/ruleSetMatch/${ruleSetKey}`,
      mappingRequest
    );
  }

  updateRuleConfigRuleMatch(ruleSetKey, mappingRequest) {
    return this.client.put(
      `${this.resourceUrl}/ruleMatch/${ruleSetKey}`,
      mappingRequest
    );
  }
}
